import { map } from 'rxjs';
import { memo } from '../util/index.js';
import { erasHistoricApplyAccount } from './util.js';
export function _stakerSlashes(instanceId, api) {
  return memo(instanceId, (accountId, eras, withActive) => {
    const stakerId = api.registry.createType('AccountId', accountId).toString();
    return api.derive.staking._erasSlashes(eras, withActive).pipe(map(slashes => slashes.map(_ref => {
      let {
        era,
        nominators,
        validators
      } = _ref;
      return {
        era,
        total: nominators[stakerId] || validators[stakerId] || api.registry.createType('Balance')
      };
    })));
  });
}
export const stakerSlashes = /*#__PURE__*/erasHistoricApplyAccount('_stakerSlashes');